<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger
      class="hamburger-container"
      :toggleClick="toggleSideBar"
      :isActive="sidebar.opened"
    ></hamburger>
    <levelbar v-model="isMobile" v-if="!isMobile"></levelbar>
    <tabs-view v-model="isMobile" v-if="!isMobile"></tabs-view>
    <error-log
      v-if="log.length > 0"
      class="errLog-container"
      :logsList="log"
    ></error-log>
    <screenfull class="screenfull"></screenfull>
    <el-dropdown class="avatar-container" trigger="click">
      <span class="el-dropdown-link">
        {{ realName }}     <i class="el-icon-caret-bottom el-icon--right"></i>
      </span>

    <!--   <element class="avatar-wrapper">
        <img class="user-avatar" src="/static/images/logo.png" />
        <i class="el-icon-caret-bottom el-icon--right"></i>
      </element>-->  
 

      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <el-dropdown-item
          ><span @click="reset" style="display: block"
            >修改密码</span
          ></el-dropdown-item
        >
        <el-dropdown-item
          ><span @click="logout" style="display: block" 
            >退出登录</span
          ></el-dropdown-item
        >
      </el-dropdown-menu>
      <el-dialog
        title="修改密码"
        :visible.sync="dialogVisible"
        width="30%"
        center
      >
        <div >
          <el-form
            :model="formData"
            ref="formData"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="用户名">
              {{ userName }}
            </el-form-item>

            <el-form-item
              label="原始密码"
              prop="password"
              :rules="{
                required: true,
                message: '原密码不能为空',
                trigger: 'blur',
              }"
            >
              <el-input
                type="password"
                v-model="formData.password"
                placeholder="请输入原始密码"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="重置密码"
              prop="newPas"
              :rules="{
                required: true,
                message: '新密码不能为空',
                trigger: 'blur',
              }"
            >
              <el-input
                type="password"
                v-model="formData.newPas"
                placeholder="请输入新密码"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="确认密码"
              prop="reNewPas"
              :rules="{
                validator: checkrepass,
                required: true,
                trigger: 'blur',
              }"
            >
              <el-input
                type="password"
                v-model="formData.reNewPas"
                placeholder="请再次输入新密码"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetPassword" type="primary">保存</el-button>
          <el-button @click="dialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </el-dropdown>
  </el-menu>
</template>

<script>
import Api from "@/services";
import { mapGetters } from "vuex";
import Levelbar from "./Levelbar";
import TabsView from "./TabsView";
import Hamburger from "components/Hamburger";
import Screenfull from "components/Screenfull";
import ErrorLog from "components/ErrLog";
import errLogStore from "store/errLog";

export default {
  components: {
    Levelbar,
    TabsView,
    Hamburger,
    ErrorLog,
    Screenfull,
  },
  data() {
    return {
      log: errLogStore.state.errLog,
      isMobile: true,
      dialogVisible: false,
      formData: {
        userId: "",
        password: "",
        newPas: "",
        reNewPas: "",
      },
      userInfo: "",
    };
  },
  computed: {
    ...mapGetters(["sidebar", "userName","realName","avatar", "groupType"]),
  },
  methods: {
    resetPassword() {
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
      });

      console.log(this.formData);

      Api.sysUpdatePassword(this.formData)
        .then((res) => {
          console.info(res);
          if (res.success) {
            this.$message.success(res.message);
            this.dialogVisible = false;
          } else {
            this.$message.error(res.message);
          }
          loading.close();
        })
        .catch((error) => {
          this.$message.error(error.message);
          loading.close();
        });
    },
    reset() {
      this.dialogVisible = true;
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        localStorage.clear();

        this.$router.push("/login");
        location.reload();
      });
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    checkrepass(rule, value, callback) {
      let vueIdex = rule.fullField.split(".")[1];
      let cal = callback;
      if (value === "" || value != this.formData.newPas) {
        cal(new Error("密码不一致"));
      } else {
        cal();
      }
    },
  },
  mounted() {
    if (this._isMobile()) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.formData.userId = this.userInfo.id;
  },
  created() {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  display: flex;
  justify-items: center;
  align-items: center;
 
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  margin-top: 65px;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 10px 10px 5px;
    display: flex;
    justify-items: center;
    align-items: center;

   
  }
  .errLog-container {
    display: inline-block;
    position: absolute;
    right: 150px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;

  }
  .dialog-body{
   
  }
  .avatar-container {
 
    height: 		65px;
    display: inline-block;
    position: fixed;
    right: 35px;
    z-index: 9999999;
    top: 0px;
    display: flex;
    justify-items: center;
    align-items: center;

    .avatar-wrapper {
      cursor: pointer;

      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        background-color: aqua;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 20px;
      }
    }
  }
  .el-dropdown-link {
    color: #ffffff;
    font-size: 20px;
  }
}
</style>






// WEBPACK FOOTER //
// Navbar.vue?3edf5b2a